export const features = [
    {
        order : 0,
        title1 : "World-Class Learning for",
        title2 : "Anyone, Anywhere",
        desc : "Studynotion partners with more than 275+ leading universities and companies to bring flexible, affordable, job-relevant online learning to individuals and organizations worldwide.",
        btn : "Learn More"
    },

    {
        order : 1,
        title : "Curriculum Based on Industry Needs",
        desc : "Save time and money! The Belajar curriculum is made to be easier to understand and in line with industry needs.",
    },

    {
        order : 2,
        title : "Our Learning Methods",
        desc : "Studynotion partners with more than 275+ leading universities and companies to bring",
    },

    {
        order : 3,
        title : "Certification",
        desc : "Studynotion partners with more than 275+ leading universities and companies to bring",
    },

    {
        order : 4,
        title : `Rating "Auto-grading"`,
        desc : "Studynotion partners with more than 275+ leading universities and companies to bring",
    },

    {
        order : 5,
        title : "Ready to Work",
        desc : "Studynotion partners with more than 275+ leading universities and companies to bring",
    },
]

export const acheivementData = [
    {
        title : "5K",
        desc : "Active Students"
    },

    {
        title : "10+",
        desc : "Mentors"
    },

    {
        title : "200+",
        desc : "Courses"
    },

    {
        title : "50+",
        desc : "Awards"
    },
]